import React from 'react';
import { socialsBarPropTypes } from './SocialsBarPropTypes';
import Container from '@Theme/natucare/components/Container/Container';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './SocialsBar.module.scss';
const SocialsBar = _ref => {
  let {
    socials,
    isMobileOpen
  } = _ref;
  if (!socials) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${isMobileOpen ? styles.rootMobileOpened : ''}`,
    role: "presentation"
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootSocials
  }, socials.map((item, index) => /*#__PURE__*/React.createElement("a", {
    href: item.href,
    title: item.title,
    rel: "noopener noreferrer",
    target: "_blank",
    className: styles.rootLink,
    key: index
  }, /*#__PURE__*/React.createElement(Icon, {
    name: item.icon,
    size: {
      width: 32,
      height: 32
    },
    classname: styles.rootLinkIcon
  }))))));
};
export default SocialsBar;